import { Image } from 'expo-image';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Text, tokens } from '@fhs/ui';

export interface Props {
  message: string;
  name: string;
  prizeType?: 'points' | 'offer';
  style?: StyleProp<ViewStyle>;
}

const prizeImage = {
  offer: require('./trophy.png'),
  points: require('./present.png'),
};

export function InlineChallengeAlert({ message, name, prizeType = 'points', style }: Props) {
  const imageSource = prizeImage[prizeType];
  return (
    <View style={[styles.container, style]}>
      <Image source={imageSource} resizeMode="contain" style={{ height: 45 }} />
      <Text.Ui size="sm" style={styles.content}>
        {message}{' '}
        <Text.Ui size="sm" weight="semibold">
          {name}
        </Text.Ui>
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    backgroundColor: tokens.colors.$successOpacity10,
  },
  content: {
    marginLeft: 12,
    flex: 1,
  },
  actionButton: {
    marginHorizontal: -8,
    marginTop: 4,
    alignSelf: 'flex-end',
  },
  hideButton: {
    margin: -8,
    marginLeft: 4,
  },
});
